export default __webpack_public_path__ + "static/media/README.de8fd08e.md";